
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SectorsSection from './components/SectorsSection';
import ServicesSection from './components/ServicesSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import ContactSection from './components/ContactSection';

export default function HomePage() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <SectorsSection />
        <ServicesSection />
        <DifferentiatorSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
